<template>
  <van-popup v-model:show="showCity" round position="bottom" safe-area-inset-bottom>
    <van-picker
      class="seriesModels"
      title="请选择所在省市"
      :ref="refCity"
      :visible-item-count="9"
      @change="onChange"
      :columns="provinceCityColumnsList"
      @confirm="confirmCity"
      @cancel="showCity = false"
    />
  </van-popup>
</template>

<script>
import { reactive, toRefs, watch, onMounted, nextTick } from 'vue'
import { getProvinceCity } from '@/api/plan'
import { getAllProvinces } from '@/api/tyre'
import { setSession, getSession } from '@/util'
import { useStore } from 'vuex'
import { onBeforeRouteLeave } from 'vue-router'
export default {
  emits: ['getCity'],
  props: ['showNum', 'fromTyre', 'fromCompleteInfo', 'indexArr', 'provinceCity'],
  setup(props, { emit }) {
    let { showNum, fromTyre, fromCompleteInfo, indexArr, provinceCity } = toRefs(props)
    let store = useStore()
    const state = reactive({
      fromTyre,
      fromCompleteInfo,
      showCity: false,
      showNum,
      provinceCityColumnsList: [],
      provinceCityList: '',
      provinceCityAllList: '',
      indexArr,
      provinceCity
    })
    onBeforeRouteLeave(() => {
      state.showCity = false
    })
    let elm = ''
    const refCity = el => {
      elm = el
    }
    const onChange = values => {
      if (!state.fromTyre && !state.fromCompleteInfo) {
        let list = state.provinceCityList
        elm.setColumnValues(1, list[values[0]])
      }
    }
    const selectCityFn = async () => {
      if (state.fromTyre || state.fromCompleteInfo) {
        let result = []
        let list = getSession('getAllProvinces')
        if (!list) {
          let { provinces } = await getAllProvinces()
          list = provinces
        }
        for (const item of list) {
          let cities = item.cities
          let children = cities.map(subItem => {
            subItem.text = subItem.name
            return subItem
          })
          result.push({
            text: item.name,
            provinceId: item.id,
            children
          })
        }
        state.provinceCityAllList = result
        state.provinceCityColumnsList = result
      } else {
        let result = {}
        let list = getSession('getProvinceCity')
        if (!list) {
          list = await getProvinceCity()
          setSession('getProvinceCity', list)
        }
        for (const item of list) {
          result[item.name] = item.cities.length ? item.cities : [item.name]
        }
        state.provinceCityList = result
        state.provinceCityColumnsList = [{ values: Object.keys(result) }, { values: result['安徽省'] }]
        // console.log(state.provinceCityColumnsList)
      }
    }
    const confirmCity = (val, i) => {
      state.showCity = false
      let data = {}
      let currentCity = {}
      if (state.fromTyre) {
        currentCity = val[1]
        data = val[1]
        currentCity.indexArr = data.indexArr = i
        store.commit('SETCURRENTCITY', currentCity)
        emit('getCity', { provinceInfo: val[0], ...data })
      } else if (state.fromCompleteInfo) {
        currentCity = val[1]
        data.provinceName = val[0].text
        data.cityName = val[1].text
        data.text = `${val[0].text}/${val[1].text}`
        data.provinceCity = [val[0].text, val[1].text]
        currentCity.indexArr = data.indexArr = i

        store.commit('SETCURRENTCITY', currentCity)
        state.indexArr = data.indexArr
        emit('getCity', { ...data })
      } else {
        data = val[1]
        currentCity = {
          name: data
        }

        store.commit('SETCURRENTCITY', currentCity)
        emit('getCity', data)
      }
    }
    watch(
      () => state.showNum,
      () => {
        state.showCity = true
        let indexArr = state.indexArr
        if (indexArr) {
          // 反选
          nextTick(() => {
            elm.setColumnValues(1, state.provinceCityAllList[indexArr[0]].children)
            elm.setIndexes(indexArr)
          })
        } else {
          // 首次进入定位位置
          if (!state.provinceCity || state.indexArr) return
          let i1 = state.provinceCityAllList.findIndex(item => item.provinceId === state.provinceCity[0] || item.text === state.provinceCity[0])
          let cityArr = state.provinceCityAllList[i1].children
          let i2 = cityArr.findIndex(item => item.id === state.provinceCity[1] || item.text === state.provinceCity[1])
          nextTick(() => {
            elm.setColumnValues(1, cityArr)
            state.indexArr = [i1, i2]
            elm.setIndexes([i1, i2])
          })
        }
      }
    )
    onMounted(() => {
      selectCityFn()
    })
    return {
      ...toRefs(state),
      refCity,
      selectCityFn,
      confirmCity,
      onChange
    }
  }
}
</script>
